import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
  fetch as fetchFate,
  purchaseItem,
} from 'actions/fate';
import { changeAvatarSuccess } from 'actions/fate/changeAvatar';
import { setAvatarImage } from 'actions/myself';

import Image from 'components/Image';
import ConfirmModal from './ConfirmModal';

export class Avatar extends Component {
  state = {
    isConfirmModalOpen: false,
    isSubmitting: false,
    isSuccess: false,
    message: undefined,
    purchaseComplete: false,
  }

  makeRequest = async (req) => {
    const { avatar, dispatch, isFree } = this.props;
    // If changing our face is free, use setAvatarImage
    if (isFree) {
      return dispatch(setAvatarImage(req));
    }
    // Otherwise, use purchaseItem
    const data = await dispatch(purchaseItem(req));
    if (data.isSuccess) {
      dispatch(changeAvatarSuccess({ avatarImage: avatar }));
    }
    return data;
  }

  handleCloseModalStack = () => {
    const { onRequestClose } = this.props;
    this.handleCloseConfirmModal();
    onRequestClose();
  }

  handleCloseConfirmModal = () => {
    this.setState({ isConfirmModalOpen: false });
  }

  handleConfirm = async () => {
    const {
      activePurchase,
      dispatch,
      isFree,
      avatar: avatarImage,
    } = this.props;
    const { isSubmitting } = this.state;

    if (isSubmitting) {
      return;
    }

    this.setState({ isSubmitting: true });

    // The endpoint and the data we need to send vary depending on whether this face change
    // is free or costs Fate
    const data = isFree ? { avatarImage } : { avatarImage, storeItemId: activePurchase.id };
    const { isSuccess, message } = await this.makeRequest(data);

    // If we spent our Licence to Amend Your Face, then we should re-fetch Fate,
    // but we don't need to await it
    dispatch(fetchFate());

    // Update our local state
    this.setState({
      isSuccess,
      message,
      isSubmitting: false,
      purchaseComplete: true,
    });
  }

  handleImageClick = () => {
    const { disabled } = this.props;
    if (!disabled) {
      this.setState({ isConfirmModalOpen: true });
    }
  }

  render = () => {
    const { avatar, isFree, fateCost } = this.props;
    const {
      isConfirmModalOpen,
      isSubmitting,
      isSuccess,
      purchaseComplete,
      message,
    } = this.state;
    return (
      <Fragment>
        <Image
          alt={avatar}
          height={100}
          icon={avatar}
          onClick={this.handleImageClick}
          type="cameo"
        />
        <ConfirmModal
          avatar={avatar}
          fateCost={fateCost}
          isFree={isFree}
          isOpen={isConfirmModalOpen}
          isSubmitting={isSubmitting}
          isSuccess={isSuccess}
          message={message}
          onConfirm={this.handleConfirm}
          onRequestClose={this.handleCloseConfirmModal}
          onRequestCloseModalStack={this.handleCloseModalStack}
          purchaseComplete={purchaseComplete}
        />
      </Fragment>
    );
  }
}

Avatar.propTypes = {
  avatar: PropTypes.string.isRequired,
  disabled: PropTypes.bool.isRequired,
  fateCost: PropTypes.number.isRequired,
  isFree: PropTypes.bool.isRequired,
  onRequestClose: PropTypes.func.isRequired,
};

export default connect()(Avatar);